import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "modal-emission-steps",
  class: "modal modal-wide fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content px-3 pb-4" }
const _hoisted_4 = { class: "modal-body py-2" }
const _hoisted_5 = { class: "img-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "pb-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "loading-bar-background" }
const _hoisted_10 = { class: "d-flex justify-content-between mt-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

import { Modal } from 'bootstrap'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'

  import { ref, onMounted, computed } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalEmissionSteps',
  setup(__props, { expose: __expose }) {

  const clockGif = new URL(
    '../../../assets/images/aguardando.gif',
    import.meta.url,
  ).href
  const clockCompletedImg = new URL(
    '../assets/clock-completed.png',
    import.meta.url,
  ).href

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const emissionStep = ref(0)
  const interval = ref<any>(null)

  const currentMessageIndex = ref(0)

  const pluginStore = usePlugin()

  const messages = [
    'Aguarde...',
    'Permaneça na página...',
    'Em breve seu certificado será emitido...',
  ]

  const emissionLabel = computed(() => {
    if (emissionStep.value === 1) {
      return 'Gerando chaves...'
    }

    if (emissionStep.value === 2) {
      return 'Emitindo Certificado...'
    }

    if (emissionStep.value === 3) {
      return 'Emissão concluída!'
    }

    return ''
  })

  const message = computed(() => {
    if (emissionStep.value === 3) {
      return 'Certificado emitido!'
    }

    return messages[currentMessageIndex.value]
  })

  const modalImage = computed(() => {
    if (emissionStep.value === 3) {
      return clockCompletedImg
    }
    return clockGif
  })

  const step = computed(() => emissionStep.value)

  onMounted(() => {
    modal.value = new Modal('#modal-emission-steps', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  const canShowSteps = computed(() => {
    if (emissionStep.value === 0) {
      return false
    }

    if (!pluginStore.certificateIssuedAtWasChecked) {
      return false
    }

    return pluginStore.issuedAt?.trim()?.length === 0
  })

  function startCarousel() {
    clearInterval(interval.value)

    interval.value = setInterval(() => {
      if (emissionStep.value === 3) {
        clearInterval(interval.value)
      }

      if (currentMessageIndex.value === messages.length - 1) {
        currentMessageIndex.value = 0
        return
      }

      currentMessageIndex.value += 1
    }, 2500)
  }

  function show() {
    startCarousel()
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function setEmissionStep(newStep: number) {
    emissionStep.value = newStep
    startCarousel()
  }

  __expose({
    show,
    hide,
    setEmissionStep,
    step,
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "clock-img",
              src: modalImage.value,
              alt: "clock-image"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(message.value), 1)
          ]),
          (canShowSteps.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["loading-bar", {
                  'third-step': emissionStep.value === 3,
                  'second-step': emissionStep.value === 2,
                }])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(emissionLabel.value), 1),
                  (emissionLabel.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Passo " + _toDisplayString(emissionStep.value) + "/3", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, " "))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})